import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group/tile bg-grey-100 relative z-0 flex flex-col overflow-hidden',
    link: 'absolute inset-0 z-10 cursor-pointer opacity-0',
    imageContainer: 'relative aspect-square w-full overflow-hidden',
    imageWrapper: 'bg-bg-page relative h-full w-full',
    image: 'h-full w-full object-cover',
    structureImage:
      'absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-200 group-hover/tile:opacity-100',
    labels:
      'absolute top-2 left-2 flex max-w-[180px] flex-wrap gap-1 max-md:right-8',
    checkbox: 'absolute bottom-7 left-4 z-30 max-md:bottom-4 max-md:left-0',
    outOfStockLabel:
      'absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2 transform',

    content: '-mt-3 flex flex-1 flex-col gap-3 px-1 md:gap-[18px] md:px-4',
    header: 'relative flex items-center justify-between',
    brandContainer: 'relative z-20',
    options: 'relative z-20 min-h-6',
    rating:
      'heading-xs md:heading-s -top-8 flex items-center gap-1.5 rounded-full bg-white px-2 max-md:absolute max-md:-top-6 max-md:right-0',
    starIcon: 'text-icon-star size-4',
    info: '',
    title:
      'md:heading-m-bold heading-s-bold relative z-9 line-clamp-2 cursor-pointer leading-tight select-none max-md:min-h-10 md:min-h-12.5',
    description:
      'md:heading-s heading-xs mt-1 line-clamp-2 min-h-10 md:min-h-12',
    bottom: 'mt-auto flex flex-col gap-3 md:gap-0',
    actions: 'relative z-20 flex flex-col gap-1',
    actionButton: 'md:-mx-4',
    buttonBuyPrice:
      'justify-center max-md:flex-col max-md:items-start max-md:gap-0 max-md:p-0',
    buttonBuyPriceValue: 'heading-xl md:heading-2xl',
    wishlist:
      'absolute top-2 right-2 z-20 size-6 group-hover/tile:opacity-100 md:size-8 md:opacity-0',
    informer: 'h-[50px] items-end'
  },
  variants: {
    wishlist: {
      true: {
        wishlist: 'md:opacity-100'
      }
    },
    catalog: {
      true: {
        rating: 'max-md:right-[inherit] max-md:left-0'
      }
    }
  },
  defaultVariants: {
    wishlist: false
  }
});
